import React, { useState } from "react";
import { Col, Row, Form, Select, Input, Checkbox, Tooltip } from "antd";
import { OPTIONAL_VALUES } from "@frontend/constants/initialValues";
import { InfoCircleOutlined } from "@ant-design/icons";

const ExperienceEducationForm = ({ form, initialValues, readonly }) => {
  const [showMininumAge, setShowMininumAge] = useState(
    initialValues.age_options === 2 ? 2 : null
  );
  const { getFieldDecorator } = form;

  return (
    <>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 0 }}>
          <Form.Item label="Educación">
            {getFieldDecorator("education_required", {
              initialValue: initialValues.education_required,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 2 }}>
          <Form.Item label="Experiencia">
            {getFieldDecorator("experience_required", {
              initialValue: initialValues.experience_required,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 0 }}>
          <Form.Item label="Edad">
            {getFieldDecorator("age_options", {
              initialValue: initialValues.age_options,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
                onSelect={(value) => setShowMininumAge(value)}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>

          {showMininumAge === 2 && (
            <Form.Item
              label="Edad minima requerida (Opcional)"
              className="input-age-container"
            >
              {getFieldDecorator("age_minimum", {
                initialValue: initialValues.age_minimum,
              })(<Input type="number" disabled={readonly == true} min="0" />)}
            </Form.Item>
          )}
        </Col>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 2 }}>
          <Form.Item label="Género">
            {getFieldDecorator("gender_options", {
              initialValue: initialValues.gender_options,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 0 }}>
          <Form.Item label="Etnia">
            {getFieldDecorator("ethnicity_options", {
              initialValue: initialValues.ethnicity_options,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 2 }}>
          <Form.Item label="Nacionalidad">
            {getFieldDecorator("nationality_options", {
              initialValue: initialValues.nationality_options,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 0 }}>
          <Form.Item label="Lugar de residencia">
            {getFieldDecorator("residence_options", {
              initialValue: initialValues.residence_options,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 2 }}>
          <Form.Item label="Confirmar autorización de datos">
            {getFieldDecorator("applicant_autorization_options", {
              initialValue: initialValues.applicant_autorization_options,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24 }}>
          <Form.Item label="Número de documento (Rut / CURP / DNI)">
            {getFieldDecorator("required_rut", {
              initialValue: initialValues.required_rut,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator("validate_document", {
              valuePropName: "checked",
              initialValue: initialValues.validate_document ?? true,
            })(
              <Checkbox disabled={readonly == true}>
                Aplicar validación{" "}
                <Tooltip title="El candidato deberá postular con un número de documento válido">
                  <InfoCircleOutlined />
                </Tooltip>
              </Checkbox>
            )}
          </Form.Item>
        </Col>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 2 }}>
          <Form.Item label="RFC">
            {getFieldDecorator("rfc_options", {
              initialValue: initialValues.rfc_options,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24 }}>
          <Form.Item label="NSS">
            {getFieldDecorator("nss_options", {
              initialValue: initialValues.nss_options,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col sm={{ span: 11 }} xs={{ span: 24, offset: 2 }}>
          <Form.Item label="Estado civil">
            {getFieldDecorator("civil_status_options", {
              initialValue: initialValues.civil_status_options,
            })(
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24 }}>
          <Form.Item label="Código postal">
            {getFieldDecorator("postal_code_options", {
              initialValue: initialValues.postal_code_options,
            })(              
              <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Selecciona una opción"
                disabled={readonly == true}
              >
                {OPTIONAL_VALUES.map((item) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    label={`${item.name}` || ""}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>)
            }
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default ExperienceEducationForm;
